import type VueRouter from 'vue-router';
import type { Pinia } from 'pinia';
import loginGuard from './login';
import referrerGuard from './referrer';
import titleGuard from './title';
import backgroundGuard from './background';
import { trackPageEndGuard, trackPageEnterGuard } from './tracker';

export function installGuards(router: VueRouter, pinia: Pinia) {
  /**
   * 顺序有要求，请勿随意调整
   */
  [
    backgroundGuard, //beforeEach
    loginGuard, // beforeEach
    referrerGuard, // beforeEach
    trackPageEndGuard, // beforeEach
    titleGuard, // afterEach
    trackPageEnterGuard, // afterEach
  ].forEach((guard) => guard(router, pinia));
}
